import React from "react";

export const FIELD_APP_HELP_TITLE = "App de Campo";

export function FieldAppHelpContent() {
  return (
    <>
      <p>
        <strong>Para que serve?</strong> Esta área concentra tudo o que chega
        pelo <strong>aplicativo de campo</strong> — trabalhos, rastreamento,
        abastecimentos, manutenções, comunicação e demais registros feitos pelos
        operadores no tablet.
      </p>

      <p>
        <strong>Primeiro passo — Alterar seleção:</strong>
      </p>
      <p>
        Ao abrir o App de Campo, a primeira tela pede que você defina o que
        quer consultar. Clique em <strong>Continuar</strong> só depois de
        ajustar os filtros abaixo.
      </p>
      <ol>
        <li>
          <strong>Operador</strong> — escolha quem trabalhou no período. De
          preferência, selecione <strong>um operador por vez</strong> para
          facilitar a leitura; também é possível marcar mais de um.
        </li>
        <li>
          <strong>Máquina</strong> — filtre pela máquina que ele operou. Se
          não escolher nenhuma, ficam <strong>todas as máquinas</strong> daquele
          operador no período.
        </li>
        <li>
          <strong>Período</strong> — de preferência, abra{" "}
          <strong>uma semana por vez</strong> (atalho “Última semana”). Também
          há opções de mês e período personalizado.
        </li>
      </ol>

      <p>
        <strong>Depois de continuar — dias e abas:</strong>
      </p>
      <ul>
        <li>
          O rastreamento abre no <strong>último dia</strong>. Os outros dias
          da semana já entram na memória em segundo plano. Clique em mais
          dias ou em <strong>Semana inteira</strong> para ver o restante sem
          esperar o servidor de novo.
        </li>
        <li>
          Use <strong>Alterar seleção</strong> a qualquer momento para mudar
          operador, máquina ou período.
        </li>
      </ul>

      <p>
        <strong>O que você encontra nas abas:</strong>
      </p>
      <ul>
        <li>
          <strong>Resumo</strong> — visão geral do que foi registrado no
          período.
        </li>
        <li>
          <strong>Rastreamento</strong> — mapa, telemetria e trajeto das
          sessões de trabalho.
        </li>
        <li>
          <strong>Comunicação</strong> — áudios e mensagens entre operadores e
          gestores.
        </li>
        <li>
          <strong>Controle de combustível</strong> — abastecimentos com litros,
          horímetro e foto do painel.
        </li>
        <li>
          <strong>Máquinas operadas</strong> — quais máquinas foram assumidas
          no período.
        </li>
        <li>
          <strong>Eventos, Insumos, Telemetria, Manutenções, Check de
          calibragem</strong> — demais registros enviados pelo app.
        </li>
        <li>
          <strong>Ações pendentes e alertas</strong> (atalho na barra lateral) —
          encerramentos incompletos, medidor sem variação, velocidade acima do
          limite e demais itens que precisam de atenção do gestor.
        </li>
      </ul>

      <p>
        <strong>Resumo:</strong> escolha operador, máquina (ou todas) e
        período; selecione os dias desejados; navegue pelas abas para ver
        tudo o que subiu pelo app — do rastreamento ao combustível e às
        pendências.
      </p>
    </>
  );
}
